import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateProviderRequest, Provider } from '../api/provider';


@Injectable({
    providedIn: 'root',
})
export class InsuranceProvidersService {
    constructor(private http: HttpClient) {}

    fetchAllInsuranceProviders(): Observable<Provider[]> {
        return this.http.get<Provider[]>('/admin/providers');
    }

    fetchProviderLogo(providerId: string): Observable<any> {
        return this.http.get(`/admin/providers/${providerId}/logo`);
    }

    fetchProvider(providerId: string): Observable<any> {
        return this.http.get(`/admin/providers/${providerId}`);
    }

    createProvider(provider: CreateProviderRequest): Observable<Provider> {
        return this.http.post<Provider>('/admin/providers', provider);
    }

    uploadLogo(providerId: string, payload: any): Observable<any> {
        return this.http.post(`/admin/providers/${providerId}/logo`, payload);
    }
}
